import { useEffect, useState } from 'react';
import { cookieUtils } from '@/utils/cookieUtils';

/**
 * Hook to manage authentication token
 * Replaces Redux token management with cookie-based storage
 */
export const useAuth = () => {
    const [token, setTokenState] = useState<string | null>(() =>
        cookieUtils.getAuthToken() || null
    );

    const setToken = (newToken: string | null) => {
        if (newToken) {
            cookieUtils.setAuthToken(newToken);
            setTokenState(newToken);
        } else {
            cookieUtils.removeAuthToken();
            setTokenState(null);
        }
    };

    const clearToken = () => {
        cookieUtils.removeAuthToken();
        setTokenState(null);
    };

    // Sync with cookie changes
    useEffect(() => {
        const cookieToken = cookieUtils.getAuthToken() || null;
        if (cookieToken !== token) {
            setTokenState(cookieToken);
        }
    }, [token]);

    return {
        token,
        setToken,
        clearToken,
        isAuthenticated: !!token,
    };
};
